/* eslint-disable no-console */
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { inject } from 'alfa';
import { withRouter } from 'react-router-dom';

import { LoadingBlock } from '../loading';
import AccountRepo from '../../repository/account';

const shouldLoad = (account, accountID) => accountID && (!account || accountID !== account.id);

const AccountLoader = ({ business, account, match: { params: { accountID } }, set, ...props }) => {
  console.debug('[SESSION: Account loader]');
  const [loading, setLoading] = useState(shouldLoad(account, accountID));
  const loadAccount = useCallback(
    async (businessID, currentAccountID) => {
      try {
        const { data } = await AccountRepo.fetch(businessID, currentAccountID);
        set('account', data);
      } catch (error) {
        console.error('ERROR: AccountLoader: AccountRepo.fetch()', error);
      } finally {
        setLoading(false);
      }
    }, [set],
  );

  useEffect(() => {
    if (!shouldLoad(account, accountID)) {
      return;
    }

    console.debug('[SESSION: Loading account]');
    loadAccount(business, accountID);
  }, [business, accountID, account, loadAccount]);

  if (!accountID) {
    // not need to do anything
    set('account', null);
    return props.children;
  }

  if (loading) {
    return <LoadingBlock />;
  }

  return props.children;
};

AccountLoader.propTypes = {
  account: PropTypes.shape({
    id: PropTypes.any,
  }),
  business: PropTypes.object,
  children: PropTypes.node,
  match: PropTypes.shape({
    params: PropTypes.shape({
      accountID: PropTypes.string,
    }),
  }),
  set: PropTypes.func,
};

export default inject(withRouter(AccountLoader), ['set', 'business', 'account'], ['business', 'account']);
